import React from 'react';
import { useLoader } from '../../providers/LoaderProvider';
import { transformHTMLParserLinks } from '../../../../utils/rewriteLink/rewriteLink';
import Benefits from '../Benefits/Benefits';
import DataEntryForm from '../DataEntryForm/DataEntryForm';
import { AcquisitionsLoader } from '../../../AcquisitionsLoader/AcquisitionsLoader';

interface IFormAreaProps {
    formSubtitle?: string;
    version?: string;
    id?: string;
    cityStateRetrievalEnabled?: boolean;
};

export const FormArea = (props: IFormAreaProps) => {
    const {shouldRenderLoader} = useLoader();
    return (
        <React.Fragment>
            <div className={shouldRenderLoader ? '' : 'hidden'}>
                <AcquisitionsLoader
                    processingSteps={shouldRenderLoader ? ['Matching your profile', 'Checking your eligibility'] : []}
                />
            </div>
            <div className={shouldRenderLoader ? 'hidden': ''}>
                {props.formSubtitle && props.version === 'versionA' && (
                    <p className='text-center'>{transformHTMLParserLinks(props.formSubtitle.replace(/\*/g, '<span class="PqDataEntryForm__asterisk">*</span>'))}</p>
                )}
                <Benefits />
                <div className='PqDataEntryForm__container' data-aa-pre-qualification={props.id}>
                    <DataEntryForm
                        cityStateRetrievalEnabled={props.cityStateRetrievalEnabled}
                        isSingleAddressField={props.version === 'singleAddressVariant' ? true : false}
                        isInvalidAddressPopUpVariant={props.version === 'invalidAddressPopUpVariant' ? true : false}
                        isAddressLockVariant={props.version === 'addressLockVariant'}
                    />
                </div>
            </div>
        </React.Fragment>
    )
};